import Textarea from 'shared/shared-component/components/Textarea';

export default Textarea;
